import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Layout} from "reactjs-admin-lte";

import NavigationSidebar from '../NavigationSidebar'
import HeaderBar from '../HeaderBar'

import {ActionTypes} from './model'

import './app.css'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            routes: [
                {name: "Search", path: "/trp/search/", icon: "search", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "ControlTower", "Carrier"]},
                {name: "Shipment Plans", path: "/trp/shipmentplan/", icon: "book", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier", "Supplier"]},
                {name: "Transportation Orders", path: "/trp/transorder/", icon: "list-alt", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier", "Supplier"]},
                {name: "Carrier view", path: "/trp/booking/", icon: "truck", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "ControlTower", "Carrier"]},
                {name: "Shipping Notices", path: "/trp/asn/", icon: "list", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier"]},
                {name: "In-transit / Milkrun", path: "/trp/milkrun/", icon: "globe", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "ControlTower", "Carrier", "YardOperator"]},
                {name: "Suppliers", path: "/trp/supplier/", icon: "industry", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier", "Supplier", "VASupplierPortal0220", "VASupplierPortal0300", "VASupplierPortal0330", "VASupplierPortalAdmin0220", "VASupplierPortalAdmin0300", "VASupplierPortalAdmin0330"]},
                {name: "Pricing", path: "/trp/pricing", icon: "money", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner"]},
                {name: "Calendars", path: "/trp/calendar/", icon: "calendar", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier"]},
                {name: "Packaging", path: "/trp/packaging/", icon: "archive", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "Carrier"]},
                {name: "Palletization", path: "/trp/palletization/", icon: "th", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower"]},
                {name: "Parts", path: "/trp/part/", icon: "cog", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "Supplier"]},
                {name: "Distribution", path: "/trp/distribution/", icon: "car", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "ControlTower", "SKDDistribution"]},
                {name: "Unloading Plan", path: "/trp/unloadingplan/", icon: "file", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "ControlTower", "Carrier", "YardOperator"]},
                {name: "Package Forwarding", path: "/trp/packageforwarding/", icon: "exchange", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "VAForkliftOperator", "ControlTower", "Carrier", "Supplier"]},
                {name: "Package Stock", path: "/trp/packagestock/", icon: "archive", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding", "VAInternalLogistics", "Supplier"]},
                {name: "Claims", path: "/trp/claim/", icon: "file-text-o", roles: ["Admin", "PortalSupplier", "VASupplierPortal0220", "VASupplierPortal0300", "VASupplierPortal0330"]},
                {name: "PPM", path: "/trp/ppm/", icon: "line-chart", roles: ["Admin", "PortalSupplier", "VASupplierPortal0220", "VASupplierPortal0300", "VASupplierPortal0330"]},
                {name: "Quantity differences", path: "/trp/quantitydiff/", icon: "balance-scale", roles: ["Admin", "VASupplierPortal0220", "VASupplierPortal0300", "VASupplierPortal0330"]},
                {name: "Monitoring", path: "/trp/monitoring/", icon: "stethoscope", roles: ["Admin", "VATransportPlanner", "VAMaterialPlanner", "VAPackageForwarding", "VAPackagePlanner", "VAForwarding"]},
            ],
            applicationName: ""
        };
        App.setTitle("Valmet Automotive")
    }

    static setTitle(title) {
        window.document.title = title;
    }

    setUsername(username) {
        this.setState({username: username});
    }

    componentDidMount() {
        // TODO: use message passing
        window.setRoutes = (routes) => {
            console.log("setRoutes(" + routes + ") disabled");
            //this.setState({routes: routes});
        };
        // TODO: use message passing
        window.setApplicationName = (appName) => {
            console.log("setApplicationName(" + appName + ")");
            App.setTitle("Valmet Automotive - " + appName);
            this.setState({applicationName: appName});
        };
        this.props.onEnter();
    }

    render() {
        const {applicationName, routes} = this.state;
        const selectedRoute = window.location.pathname;
        const {
            user: {
                username, contextType, roles, supplierIds, supplierPortalIds, carrierId
            } = {}
        } = this.props;

        const contextRoles = roles ? roles : [];

        console.log("username =", username);
        console.log("contextType =", contextType, "roles =", contextRoles);
        console.log("supplierIds =", supplierIds, "supplier portal Ids =", supplierPortalIds, "carrierId =", carrierId);

        let skin = 'green-light';
        switch (window.VA_ENV) {
            case 'TEST': skin = 'yellow-light'; break;
            case 'LOCAL': skin = 'blue-light'; break;
        }
        return (
            <Layout skin={skin}>
                <HeaderBar username={username} roles={roles} supplierIds={supplierIds} supplierPortalIds={supplierPortalIds} carrierId={carrierId} applicationName={applicationName}/>
                <NavigationSidebar routes={routes.filter((route) => route.roles.some(r => contextRoles.indexOf(r) >= 0))}
                                   selectedRoute={selectedRoute}/>
            </Layout>
        );
    }
}

export default connect(
    ({app: { user }}) => ({ user }),
    {
        onEnter: () => ({type: ActionTypes.OnEnter})
    }
)(App);
